import React from 'react'
import { useTranslation } from 'react-i18next'

import type { FooterLinkProps } from './FooterLinkLayout.tsx'
import { FooterLinkLayout } from './FooterLinkLayout.tsx'

export const LayerOneFooterLinks: React.FC = (props) => {
  const { t } = useTranslation()
  const LayerOneFooterLinkData: FooterLinkProps[] = [
    { linkName: t('navbar:layer-one.colItems.xyoLayerOne.linkText'), to: '/layer-one' },
    { linkName: t('navbar:layer-one.colItems.keyMilestones.linkText'), to: '/layer-one/milestones' },
    { linkName: t('navbar:layer-one.colItems.compare.linkText'), to: '/layer-one/compare' },
    { linkName: t('navbar:layer-one.colItems.history.linkText'), to: '/layer-one/evolution' },
    { linkName: t('navbar:layer-one.colItems.faq.linkText'), to: '/layer-one/faq' },
    { linkName: t('navbar:layer-one.colItems2.wallet.linkText'), to: '/layer-one/wallet' },
    { linkName: t('navbar:layer-one.colItems2.xl1BlockExplorer.linkText'), href: 'https://explore.xyo.network/xl1' },

  ]
  return <FooterLinkLayout links={LayerOneFooterLinkData} sectionTitle="XYO Layer One" {...props} />
}
